export const DashboardSettings = [
    {
        dimension: "drug-info",
        permutation: [
            {
                name: "form",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 5, 7, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 5, 7, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 6, 6, 4, 8, 4, 8 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 4, 8, 12 ]
                            }
                        }
                    },
                ]
            }
        ]
    },
    {
        dimension: "demographic",
        permutation: [
            {
                name: "specialty-groups",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12 ]
                        }
                    },
                    {
                        name: "specialty",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "md-specialty-clinic-hospital",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "specialty",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12, 4, 8 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "md-age-range",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "specialty",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12, 4, 8 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "md-gender",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "specialty",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12, 4, 8 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "px-age-range",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "specialty",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12, 4, 8 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "px-gender",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "specialty",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12, 4, 8 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "specialty-indications",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 12, 7, 5, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 12, 7, 5, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 12, 7, 5, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 12, 7, 5, 12 ]
                        }
                    },
                    {
                        name: "specialty",
                        settings: {
                            placeholder: [ 4, 8, 12, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 12, 7, 5, 12 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "indication-groups",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "indication",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "indication-px-gender",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "indication",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12, 4, 8 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "indication-px-age-group",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 4, 8, 12, 4, 8 ]
                        }
                    },
                    {
                        name: "indication",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 12, 4, 8 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "indication-specialties",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 12, 7, 5, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 12, 7, 5, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 12, 7, 5, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 12, 7, 5, 12 ]
                        }
                    },
                    {
                        name: "indication",
                        settings: {
                            placeholder: [ 4, 8, 12, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 12, 7, 5, 12 ]
                            }
                        }
                    },
                ]
            },
        ]
    },
    {
        dimension: "geographic",
        permutation: [
            {
                name: "4-marketing-regions",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 6, 6, 6, 6, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 5, 7, 12 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "6-key-regions",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 6, 6, 6, 6, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 5, 7, 12 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "17-regions",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 6, 6, 6, 6, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 5, 7, 12 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "82-provinces",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 6, 6, 6, 6, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 5, 7, 12 ]
                            }
                        }
                    },
                ]
            },
            {
                name: "metro-manila",
                attributes: [
                    {
                        name: "main-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "classes",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "sub-class",
                        settings: {
                            placeholder: [ 4, 8, 4, 8, 12 ]
                        }
                    },
                    {
                        name: "brand",
                        settings: {
                            placeholder: [ 6, 6, 6, 6, 12 ]
                        }
                    },
                    {
                        name: "sort",
                        type: {
                            name: "brand",
                            settings: {
                                placeholder: [ 4, 8, 5, 7, 12 ]
                            }
                        }
                    },
                ]
            },
        ]
    }
]
